import React, { createContext, useContext, useState, useEffect } from 'react';
import { setupDeviceId } from '../utils/deviceFingerprint';
import { verifyDevice } from '../services/deviceAuth';

interface DeviceAuthContextType {
  isDeviceAuthorized: boolean;
  loading: boolean;
  deviceId: string | null;
  checkDeviceAuth: () => Promise<boolean>;
}

const DeviceAuthContext = createContext<DeviceAuthContextType>({
  isDeviceAuthorized: true, // CHANGED: Always return true
  loading: true,
  deviceId: null,
  checkDeviceAuth: async () => true // CHANGED: Always return true
});

export const DeviceAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDeviceAuthorized, setIsDeviceAuthorized] = useState<boolean>(true); // CHANGED: Always true
  const [loading, setLoading] = useState<boolean>(true);
  const [deviceId, setDeviceId] = useState<string | null>(null);

  const checkDeviceAuth = async (): Promise<boolean> => {
    try {
      // Setup device ID
      const id = await setupDeviceId();
      setDeviceId(id);
      
      // CHANGED: Always return true instead of checking with server
      // const isAuthorized = await verifyDevice();
      const isAuthorized = true; // Always authorized
      setIsDeviceAuthorized(isAuthorized);
      return isAuthorized;
    } catch (error) {
      console.error('Error checking device auth:', error);
      setIsDeviceAuthorized(true); // CHANGED: Always true even on error
      return true; // CHANGED: Always return true
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkDeviceAuth();
  }, []);

  return (
    <DeviceAuthContext.Provider 
      value={{ 
        isDeviceAuthorized, 
        loading, 
        deviceId,
        checkDeviceAuth 
      }}
    >
      {children}
    </DeviceAuthContext.Provider>
  );
};

export const useDeviceAuth = () => useContext(DeviceAuthContext);